{
  "amount": "अमाउंट",
  "available": "उपलब्ध",
  "bots": "बॉट्स",
  "buyLong": "Buy / Long",
  "closePosition": "पोजीशन बंद करें",
  "cost": "कॉस्ट",
  "cross": "क्रॉस",
  "entryPrice": "एंट्री प्राइस",
  "funding": "फंडिंग",
  "fundingRate": "फंडिंग रेट",
  "futuresSettings": "फ्यूचर्स सेटिंग्स",
  "futuresSubtitle": "रीयल-टाइम फ्यूचर्स एक्सचेंज पैनल",
  "futuresTitle": "EXALT फ्यूचर्स ट्रेडिंग",
  "highVolatility": "हाई वोलैटिलिटी",
  "importantNotice": "महत्वपूर्ण सूचना: EXALT फ्यूचर्स मार्केट लाइव है",
  "isolated": "आइसोलेटेड",
  "leverage": "लीवरेज",
  "limit": "लिमिट",
  "liquidation": "लिक्विडेशन",
  "liveFuturesMarket": "लाइव फ्यूचर्स मार्केट",
  "loading": "लोड हो रहा है...",
  "lowVolatility": "लो वोलैटिलिटी",
  "margin": "मार्जिन",
  "marginMode": "मार्जिन मोड",
  "markPrice": "मार्क प्राइस",
  "market": "मार्केट",
  "mobileFuturesChart": "मोबाइल फ्यूचर्स चार्ट",
  "noClosedPositions": "कोई क्लोज्ड पोजीशन नहीं",
  "noOpenPositions": "कोई ओपन पोजीशन नहीं",
  "normalCandles": "नॉर्मल कैंडल्स",
  "normalVolatility": "नॉर्मल वोलैटिलिटी",
  "openLong": "ओपन लॉन्ग",
  "openOrders": "ओपन ऑर्डर्स",
  "openPositions": "ओपन पोजीशन्स",
  "openShort": "ओपन शॉर्ट",
  "orderBook": "ऑर्डर बुक",
  "orderType": "ऑर्डर टाइप",
  "perpetualFutures": "परपेचुअल फ्यूचर्स",
  "positionHistory": "पोजीशन हिस्ट्री",
  "positions": "पोजीशन्स",
  "price": "कीमत",
  "priceMovementWarning": "नियमित ट्रेडिंग समय के बाहर कीमत की मूवमेंट और लिक्विडिटी सीमित हो सकती है।",
  "processing": "प्रोसेसिंग...",
  "quoteCurrency": "कोट करेंसी",
  "reduceOnly": "रिड्यूस ओनली",
  "riskLevel": "रिस्क लेवल",
  "searchMarket": "मार्केट खोजें...",
  "searchPair": "पेयर खोजें...",
  "sellShort": "Sell / Short",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया। कृपया पुनः लॉगिन करें।",
  "slPrice": "SL कीमत",
  "smoothCandles": "स्मूथ कैंडल्स",
  "stopLoss": "स्टॉप लॉस",
  "takeProfit": "टेक प्रॉफिट",
  "tpPrice": "TP कीमत",
  "tradingViewChart": "TradingView चार्ट",
  "volatileCandles": "वोलेटाइल कैंडल्स",
  "zoomLarge": "बड़ा ज़ूम",
  "zoomMedium": "मीडियम ज़ूम",
  "zoomSmall": "छोटा ज़ूम"
}